import { EmtButton, EmtHeader, EmtIcon, EmtNavLink, EmtTypography } from 'emt-components-v2'
import { NewsCard } from './Home'
import NextImage from 'next/image'
import { useAvatarStore } from '@/store/zustand'
import VariantImages from '@/assets/VariantImages'
import { Box, SxProps } from '@mui/material'
import { TFunction } from 'i18next'
import { Trans } from 'next-i18next'
import { Routes, SpecificModules } from '@/assets/configs'

export const IsThereAvatarBanner = ({
  showHeader = true,
  sx = {},
  t,
}: {
  showHeader?: boolean
  sx?: SxProps
  t: TFunction<'common', undefined>
}) => {
  const { setActiveAvatarModal, isThereAvatar, skippedAvatarBanner, setSkippedAvatarBanner } = useAvatarStore()

  if (!SpecificModules.missingImages) return null

  const Wrapper = ({ children }) =>
    showHeader ? (
      <EmtHeader sx={sx} background="/theme/header-pattern.png">
        {children}
      </EmtHeader>
    ) : (
      <Box sx={sx}>{children}</Box>
    )

  if (isThereAvatar && skippedAvatarBanner) return null

  if (isThereAvatar && !skippedAvatarBanner) {
    return (
      <Wrapper>
        <NewsCard elevation={0}>
          <NextImage src={VariantImages.AnalyticIcon} width={74} quality={100} alt={''} />
          <div>
            <EmtTypography variant="h5" fontWeight={800}>
              {t('bugPhoto.notification.title')}
            </EmtTypography>

            <Trans
              t={t}
              i18nKey={'bugPhoto.notification.text'}
              components={{
                Link: (
                  <EmtNavLink
                    href={Routes.MyProfile}
                    variant="body2"
                    color="primary.main"
                    fontWeight={700}
                    sx={{ fontSize: 'inherit', display: 'inline', textDecoration: 'underline' }}
                  />
                ),
              }}
            />
            <EmtIcon
              className="emt-x"
              onClick={() => setSkippedAvatarBanner(true)}
              sx={{ position: 'absolute', right: '10px', top: '10px', fontSize: '14px !important', cursor: 'pointer' }}
            />
          </div>
        </NewsCard>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <NewsCard elevation={0}>
        <NextImage src={VariantImages.AnalyticIcon} width={74} quality={100} alt={''} />
        <div>
          <EmtTypography variant="h5" fontWeight={800}>
            {t('bugPhoto.title')}
          </EmtTypography>
          <EmtTypography variant="body2">{t('bugPhoto.text')}</EmtTypography>
          <EmtButton
            size={'large'}
            onClick={() => setActiveAvatarModal(true)}
            sx={{
              paddingY: '10px',
              marginTop: '10px',
            }}
          >
            {t('bugPhoto.banner.button')}
          </EmtButton>
        </div>
      </NewsCard>
    </Wrapper>
  )
}
